import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
//? English Version
import subscribeInstruction1 from "../../assets/img/tutorialimages/subscribeGuide1.png";
import subscribeInstruction2 from "../../assets/img/tutorialimages/subscribeGuide2.png";
import subscribeInstruction3 from "../../assets/img/tutorialimages/subscribeGuide3.png";

//? Japanese Version
import subscribeInstruction1Jap from "../../assets/img/tutorialimages/subscribeGuide1_Jap.png";
import subscribeInstruction2Jap from "../../assets/img/tutorialimages/subscribeGuide2_Jap.png";
import subscribeInstruction3Jap from "../../assets/img/tutorialimages/subscribeGuide3_Jap.png";
import subscribeInstruction4Jap from "../../assets/img/tutorialimages/subscribeGuide4_Jap.png";
import subscribeInstruction5Jap from "../../assets/img/tutorialimages/subscribeGuide5_Jap.png";

class SubscribePlanGuide extends Component {
  componentWillMount() {
    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={subscribeInstruction1}
            alt="subscribeInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction2}
            alt="subscribeInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction3}
            alt="subscribeInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={subscribeInstruction1Jap}
            alt="subscribeInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction2Jap}
            alt="subscribeInstruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction3Jap}
            alt="subscribeInstruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction4Jap}
            alt="subscribeInstruction4Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction5Jap}
            alt="subscribeInstruction5Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={subscribeInstruction1}
            alt="subscribeInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction2}
            alt="subscribeInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction3}
            alt="subscribeInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default SubscribePlanGuide;
